import React from 'react';
import PropTypes from 'prop-types';
import ContentsTable from "../../contents/ContentsTable";



export default function ContentModal(param) {

    const [type, setType] = React.useState("blogs");

    function callbackContent(content) {
        param.callbackContent(content);
    }

    function typeSelect(value) {
        setType(value);
    }

    return(
        <div className="modal fade" id="contentModal" data-keyboard="false" data-backdrop="static" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-xl  modal-dialog-centered">
                <div className="modal-content">
                
                    <div className="modal-header">
                        <h4 className="modal-title">컨텐츠 조회</h4>
                        <button type="button" className="close" data-dismiss="modal">&times;</button>
                    </div>
                    
                    <div className="modal-body">
                        <div className="tab-wrapper">
                            <ul className="nav nav-tabs" id="custom-content-below-tab" role="tablist">
                                <li className="nav-item">
                                    <a className="nav-link active" id="custom-content-below-home-tab" data-toggle="pill" href="#custom-content-below-home" role="tab" aria-controls="custom-content-below-home" aria-selected="true" onClick={() => typeSelect("blogs")}>블로그</a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" id="custom-content-below-profile-tab" data-toggle="pill" href="#custom-content-below-profile" role="tab" aria-controls="custom-content-below-profile" aria-selected="false" onClick={() => typeSelect("cards")}>카드</a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" id="custom-content-below-messages-tab" data-toggle="pill" href="#custom-content-below-messages" role="tab" aria-controls="custom-content-below-messages" aria-selected="false" onClick={() => typeSelect("quiz")}>퀴즈</a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" id="custom-content-below-settings-tab" data-toggle="pill" href="#custom-content-below-settings" role="tab" aria-controls="custom-content-below-settings" aria-selected="false" onClick={() => typeSelect("surveys")}>설문</a>
                                </li>
                            </ul>
                        </div>
                        <ContentsTable callbackContent={callbackContent} type={type}></ContentsTable>
                    </div>
                    
                    {/* <div className="modal-footer">
                        <a href="#" ><button type="button" className="btn btn-primary"><i className="fas fa-edit"></i> 조회</button></a>
                    </div> */}
                    
                </div>
            </div>
        </div>
    );
}

ContentModal.propTypes = {
    data: PropTypes.any,
    callbackMessage: PropTypes.any
  };